/**
 * Asset resolution for `{type: 'asset', id}` sprite/mesh refs (plan §4.6):
 * host apps register an id → URL/Texture map, and/or a base URL that ids are
 * joined onto. Keeps effect JSON portable while assets live wherever the host
 * serves them.
 *
 *   registerAssets({ 'sparkle.png': '/textures/sparkle.png' });
 *   setAssetBaseUrl('/vfx-assets/');   // fallback: id resolves to baseUrl + id
 */
const assetMap = new Map();
let baseUrl = null;
const warned = new Set();
export function registerAssets(assets) {
    for (const [id, value] of Object.entries(assets))
        assetMap.set(id, value);
}
export function setAssetBaseUrl(url) {
    baseUrl = url && !url.endsWith('/') ? `${url}/` : url;
}
export function clearAssets() {
    assetMap.clear();
    baseUrl = null;
    warned.clear();
}
/** Resolve an asset id to a URL or an already-loaded Texture; null (with a one-shot warning) if unknown. */
export function resolveAsset(id) {
    const direct = assetMap.get(id);
    if (direct !== undefined)
        return direct;
    if (baseUrl)
        return baseUrl + id;
    if (!warned.has(id)) {
        warned.add(id);
        console.warn(`vfx-runtime: asset "${id}" is not registered and no assetBaseUrl is set — rendering white.`);
    }
    return null;
}
